export const server_types = {
  stream: {
    text: 'Stream',
    value: 'stream',
  },
  deepseek: {
    text: 'Deepseek',
    value: 'deepseek',
  },
  ollama: {
    text: 'Ollama',
    value: 'ollama',
  },
  ben_transcription: {
    text: 'Ben Transcription',
    value: 'ben_transcription',
  }
}